import { CATEGORIE_UNITAIRE } from '@/configuration/produitConf';

export default function updateQuantiteDispo(ligne) {
  if ((ligne.quantiteDispo > 0 && ligne.quantiteDispo < 1) || !ligne.affectation
    || ligne.typeProduit !== CATEGORIE_UNITAIRE) { return; }
  ligne.quantiteDispo = 1;
  ligne.affectation.forEach((affectation) => {
    ligne.quantiteDispo -= affectation.quantiteDispo;
  });
  if (ligne.quantiteDispo <= 0) ligne.quantiteDispo = 1;
}



// WEBPACK FOOTER //
// ./src/services/devisCommandes/updateQuantiteDispo.js